module.exports = __webpack_public_path__ + "fonts/ralewayitalic.3a0ec20.woff2";